<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">And There’s A God Who Is Close By</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#an-introduction-to-the-story">An Introduction to the Story</a></li><li id="toc-li-5"><a href="#/text/ch005#chapter-one-a-trips-experience">Chapter One: A Trip’s Experience</a></li><li id="toc-li-6"><a href="#/text/ch006#chapter-two-the-black-man-instilled-the-concept-of-whiteness-in-the-world">Chapter Two: The Black Man Instilled the Concept of ‘Whiteness’ in the World</a></li><li id="toc-li-7"><span href="#/text/ch007#chapter-three-a-man-on-the-precipice-of-good-and-evil" title="Link target outside of Sample">Chapter Three: A Man on the Precipice of Good and Evil</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-four-parallel-universes-theory" title="Link target outside of Sample">Chapter Four: Parallel Universes Theory</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?e95ebad8